"use strict";

const UnsubmitHistoryRecord = function () {
  const UNSUBMIT_TRIGGER_CLASS = ".js-unsubmit-record";
  let recordType = null;
  let recordName = null;
  let apiCall = null;

  var unloadDomListeners = function () {
    $(document).off("click", UNSUBMIT_TRIGGER_CLASS, handleUnsubmit);
  };

  var loadDomListeners = function ({
    recordType: _recordType,
    recordName: _recordName = null,
    apiCall: _apiCall,
  }) {
    unloadDomListeners();
    recordType = _recordType;
    recordName = _recordName;
    apiCall = _apiCall;
    $(document).on("click", UNSUBMIT_TRIGGER_CLASS, handleUnsubmit);
  };

  var handleUnsubmit = function () {
    const $row = $(this).closest(".history-item-tr");
    const date = $row.find(".date-col").text().trim();
    MessageModal.showConfirmWarningModal(
      null,
      () => apiCall($row.data("id")),
      "Cancel",
      "Unsubmit",
      _buildMessage({ recordType, recordName, date }),
    );
  };

  var _buildMessage = function ({ recordType, recordName, date }) {
    const record = recordName
      ? `${recordType} on ${date} for ${recordName}`
      : `${recordType} on ${date}`;

    return `Unsubmit ${record}? By unsubmitting, you will be able to make edits again. The previously submitted ${recordType} report will be deleted and any scheduled follow ups will be cancelled.`;
  };

  return {
    loadDomListeners,
    unloadDomListeners,
    _buildMessage,
  };
};

module.exports = UnsubmitHistoryRecord();

const MessageModal = require("../modals/messageModal");
